import cssUtil from 'gw-portals-util-js/CssUtil';

import listTemplate from 'text!./MobileLocation.html';
import listStyles from './MobileLocation-hashed.scss';

export default [function () {
    return {
        restrict: 'E',
        template: cssUtil.hashTemplate(listTemplate, listStyles),
        scope: {
            schedule: '&'
        },
        controller: ['$scope', 'AddressUtil', function ($scope, AddressUtil) {
            $scope.spellAddress = function (addrVM) {
                return AddressUtil.format(addrVM);
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/common/directives/schedules/scheduleTypes/readonly/MobileLocation/MobileLocation.js
// module id = 387
// module chunks = 0